/*
 Created by CHT 2019/12/4 10:51
 数据表格（数据表格控件）
*/

import BaseChart from "../BaseChart"
import {CHART_CATEGORY__DATA_GRID, CHART_TYPE__DATA, CHART_TYPE__FILTER_CONTROL, SOURCE_TYPE__FLOW_FORM} from "../types"
import {DASHBOARD_DATA_SOURCE_EXIST, SUCCESS} from "../../../src/store/types";
import {filterEmpty} from "../../../assets/js/Untis";

class DataGrid extends BaseChart {
  constructor() {
    super()
    this.h = 15

    this.minW = 30
    this.minH = 12

    // 图表模型相关数据属性
    this.chartPropertiesHolder = {
      filter: {
        relation: 'and',
        conditionList: []
      },
      viewId: 'dataHandle'
    }

    // 数据源类型
    this.dataSourceType = SOURCE_TYPE__FLOW_FORM

    this.header = []

    this.value = {
      currentPage: 1,
      pageSize: 20,
      totalPage: 1,
      totalCount: 1,
      timestamp: Date.now(),
      dataList: [],
      sort: {}
    }

  }

  get title() {
    return this.chartName || DataGrid._title
  }

  set title(content) {
    this.chartName = content
  }
}

DataGrid._title = '数据表格'
DataGrid.type = CHART_TYPE__DATA

DataGrid.prototype.chartCategory = CHART_CATEGORY__DATA_GRID
DataGrid.prototype.chartType = DataGrid.type
DataGrid.prototype.getValue = function (opt={}, filter) {

  if (this.hidden) {
    // 图表不可见，不用请求数据
    return
  }

  this.isLoad = false

  if (!filter) {
    const chartCondition = []
    this.parent.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .forEach(filterControl => {
        const holder = filterControl.chartPropertiesHolder
        const filterConf = holder.chartFilterMap[this.chartId]

        if (filterConf && filterControl.value.method) {
          chartCondition.push({
            type: "",
            method: filterControl.value.method,
            value: filterControl.value.value,
            fieldId: filterConf.dataId,
            fixedValue: filterControl.value.fixedValue,
            extValue: filterControl.value.extValue
          })
        }
      })

    filter = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: chartCondition,
    }
  }

  if (((this.parent.styles && this.parent.styles.filterEmptyLoadData && this.parent.styles.filterEmptyLoadData === 'NO') ||
    (this.showPropertiesHolder.filterEmptyLoadData && this.showPropertiesHolder.filterEmptyLoadData === 'NO')) && filterEmpty(filter)) {
    this.value.currentPage = 1
    this.value.totalPage = 0
    this.value.totalCount = 0
    this.header = []
    this.value.dataList.splice(0, this.value.dataList.length)
    this.isLoad = true
    return
  }

  this.parent.chartDataPreviewFun({
    chartId: this.chartId,
    currentPage: this.value.currentPage,
    pageSize: this.value.pageSize,
    sort: this.value.sort,
    chart: this.getBase(),
    filter
  }).then(({status, resultObject, info}) => {
    if (status === SUCCESS) {
      const {structHeader, dataHolder} = resultObject

      if (this.header.length === 0) {
        this.header.splice(0, this.header.length, ...structHeader)
        this.header.forEach(item => item.show = true)
      }

      this.value.currentPage = dataHolder.currentPage
      this.value.totalPage = dataHolder.totalPage
      this.value.totalCount = dataHolder.totalCount
      this.value.timestamp = dataHolder.timestamp
      this.value.dataList.splice(0,
        this.value.dataList.length,
        ...dataHolder.dataList
      )
    } else if (status === DASHBOARD_DATA_SOURCE_EXIST) {
      this.errorPrompt = '控件已删除'
    }
  }).catch(err => {
    console.error(err)
  }).finally(() => {
    this.isLoad = true
  })
}

export default DataGrid
